// Retrieve the nonce from the meta tag
const metaTag = document.querySelector('meta[property="csp-nonce"]');
if (metaTag) {
  __webpack_nonce__ = metaTag.getAttribute('content');
}
const cspNonce = metaTag ? metaTag.getAttribute('content') : null;

// Store the original createElement function
const originalCreateElement = document.createElement;

// Override document.createElement
document.createElement = function(tagName, options) {
    // Call the original createElement to create the element
    const element = originalCreateElement.call(this, tagName, options);

    // If a nonce is available and the element is a script or style tag, add the nonce attribute
    if (cspNonce && (tagName.toLowerCase() === 'script' || tagName.toLowerCase() === 'style')) {
        element.setAttribute('nonce', cspNonce);
    }

    // Return the created element
    return element;
};
window.$ = window.jQuery = require('jquery');
import * as Popper from "@popperjs/core"
// import * as bootstrap from 'bootstrap';
import { Modal, Toast } from 'bootstrap'
// import AirDatepicker from 'air-datepicker';
// import localeZh from 'air-datepicker/locale/zh';
// import 'air-datepicker/air-datepicker.css';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
// import Cookies from 'js-cookie';
import counterUp from 'counterup2';
require('waypoints/lib/noframework.waypoints.js');


window.bootstrap = {
    Modal, Toast
};
window.Swal = require('sweetalert2');
(function ($) {
    let $body = $('body');
    let $gotop = $('.gotop');
    let menuOpenSpeed = 400;

    let isMobile = false;
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) isMobile = true;

    // new AirDatepicker('.dp', {
    //     locale: localeZh,
    //     dateFormat: 'yyyy-MM-dd',
    // })
    // IE關閉smooth scroll
    if (navigator.userAgent.match(/Trident\/7\./)) {
        document.body.addEventListener("mousewheel", function () {
            event.preventDefault();
            let wd = event.wheelDelta;
            let csp = window.pageYOffset;
            window.scrollTo(0, csp - wd);
        });
    }

    $('.main').css('min-height', $(window).height() - $('.footer').outerHeight());

    $('.ticket-close').on('click', function (event) {
        $('.ticket').addClass('d-none');
        return false;
    });
    $('.header-nav-toggle').on('click', function (event) {
        $body.toggleClass('nav-open');
        $('.header-nav-menu li.open').removeClass('open');
        return false;
    });
    $('.header-nav-menu li, .header-nav-menu li').has('ul').addClass('has-child');
    $('.header-nav-menu li.has-child').hover(function (event) {
        if (!isMobile) {
            $(this).addClass('open');
        }
    }, function () {
        if (!isMobile) {
            $(this).removeClass('open');
        }
    });
    $('.header-nav-menu li.has-child > a').click(function (event) {
        if (isMobile) {
            $(this).parent().toggleClass('open');
            $(this).parent().siblings('li').removeClass('open');
            if (!$(this).parent().hasClass('open')) {
                $(this).siblings('ul').find('li').removeClass('open');
            }
            return false;
        }
    });

    if ($('.side-nav-toggle').length) {
        $('.side-nav-toggle').click(function(event) {
            $(this).toggleClass('active');
        });
        var scrollId;
        $(window).scroll(function () {
            clearTimeout(scrollId);
            scrollId = setTimeout(sideSticky, 100);
        });
        // $(window).on('scroll', sideSticky);
        sideSticky();
        function sideSticky() {
            var $sideL = $('.side .container');
            var $content = $('.has-side .content');
            var contentStart = $content.offset().top - $('.header').outerHeight();
            if ($('.side-nav-toggle').is(':hidden') && $(window).scrollTop() >= contentStart) {
                var maxOffsetSideL = $content.outerHeight() - $sideL.outerHeight();
                var scrollOffset = $(window).scrollTop() - contentStart;
                $sideL.css('top', scrollOffset>maxOffsetSideL?maxOffsetSideL:scrollOffset).addClass('side-sticky');
            } else {
                $sideL.css('top', 0).removeClass('side-sticky');
            }
        }
    }
    $('.side-nav-list li').has('ul').addClass('has-child');
    $('.side-nav-list li.has-child > a').click(function(event) {
      $(this).parent().toggleClass('open');
    //   $(this).siblings('ul').stop().slideToggle(menuOpenSpeed);
    //   $(this).parents('li').css('height', 'auto');
      if (!$(this).parent().hasClass('open')) {
        $(this).siblings('ul').find('li').removeClass('open');
        // $(this).siblings('ul').find('ul').stop().slideUp(menuOpenSpeed);
      }
      $(this).parent().siblings('li').removeClass('open')
    //   .find('ul').stop().slideUp(menuOpenSpeed);
      return false;
    });
    $(document).on('click', function (e) {
        if ($(e.target).parents('.header-nav-menu').length == 0) {
            $('.header-nav-menu li.has-child').removeClass('open');
            // $('.menu li.has-child > ul').stop().slideUp(menuOpenSpeed);
        }
        if ($(e.target).parents('.header-main-nav').length == 0) {
            $('.header-nav-menu li.has-child').removeClass('open');
            // $('.header-nav-menu li.has-child > ul').stop().slideUp(menuOpenSpeed);
        }
        if($(e.target).parents('.side-nav').length==0){
            $('.side-nav-toggle').removeClass('active');
            $('.side-nav-list li').removeClass('open');
        }
    });

    $(window).on('scroll', function (event) {
        if ($(window).scrollTop() > 50) {
            $body.addClass('header-fixed');
        } else {
            $body.removeClass('header-fixed');
        }
        if ($('.floating-subscribe').length) {
            if ($(window).scrollTop() > ($body.height() - $(window).height() - $('.footer').outerHeight()) * 0.66) {
                $body.addClass('scroll-pass');
            } else {
                $body.removeClass('scroll-pass');
            }
        }
    }).scroll();


    $(window).on('load', function() {
        gsap.registerPlugin(ScrollTrigger);
        const animes = gsap.utils.toArray('.anime');
        animes.forEach((item) => {
        gsap.to(item, {
            scrollTrigger: {
            start: 'top 90%',
            end: 'bottom top',
            trigger: item,
            toggleClass: 'anime-run',
            // endTrigger:"html",
            // end:"bottom top"
            }
        });
        });
    })
    // let lastScrollTop = $(window).scrollTop();
    // let st = $(window).scrollTop();
    // $(window).on('load', function () {
    //     $('.anime').each(function () {
    //         let currSect = $(this);
    //         $('.anime').each(function () {
    //             let currSect = $(this);
    //             if (currSect.offset().top - $(window).height() <= st) {
    //                 currSect.addClass("anime-run");
    //             }
    //         });
    //     });
    // });
    // $(window).on('scroll', function (event) {
    //     st = $(window).scrollTop();
    //     if (st > lastScrollTop) {
    //         $('.anime').each(function () {
    //             let currSect = $(this);
    //             if (currSect.offset().top - $(window).height() * 0.7 <= st && currSect.offset().top + $(window).height() * 0.7 > st) {
    //                 currSect.addClass("anime-run");
    //             }
    //         });
    //     } else {
    //         $('.anime').each(function () {
    //             let currSect = $(this);
    //             if (currSect.offset().top - $(window).height() * 0.5 <= st && currSect.offset().top > st) {
    //                 currSect.addClass("anime-run");
    //             }
    //         });
    //     }
    //     lastScrollTop = st;
    // });
    window.onload = function() {
        var lastScrollTop = $(window).scrollTop();
        if ($('.loading').length) {
            $('.loading').fadeOut(function() {
                $body.addClass('loaded');
            });
        } else {
            $body.addClass('loaded');
        }
    };

    // let cookieStatus = 1;
    // if (Cookies.get('cookieStatus')) {
    //   cookieStatus = Cookies.get('cookieStatus');
    // }
    // if (cookieStatus > 0) {
    //   $('.cookie-notice').removeClass('d-none');
    // }
    // $('.js-close-cookie').on('click', function(e) {
    //     $('.cookie-notice').addClass('d-none');
    //     cookieStatus = -1;
    //     Cookies.set('cookieStatus', cookieStatus)
    //     return false;
    // });
    const couters = document.querySelectorAll( '.counter' )
    for (let i = 0; i < couters.length; i++) {
        let el = couters[i];
        new Waypoint( {
            element: el,
            handler: function() {
                counterUp( el )
                this.destroy()
            },
            offset: 'bottom-in-view',
        } )
    }
})($);
